import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/context/AuthContext";

const SESSION_FLAG = "rudra_visit_recorded";

export default function Footer() {
  const [visitors, setVisitors] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const alreadyCounted = sessionStorage.getItem(SESSION_FLAG);
        const { data } = alreadyCounted
          ? await axios.get(`${API}/visits`)
          : await axios.post(`${API}/visits`);
        if (!cancelled) {
          setVisitors(data.total);
          if (!alreadyCounted) sessionStorage.setItem(SESSION_FLAG, "1");
        }
      } catch {
        // Counter is decorative — swallow errors silently.
      }
    };
    load();
    return () => { cancelled = true; };
  }, []);

  return (
    <footer className="border-t border-[var(--border)] mt-32">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-sacred text-3xl embossed">RUDRA ROAST COFFEE</div>
          <p className="mt-4 text-[var(--text-secondary)] max-w-md leading-relaxed">
            Small-batch coffee roasted in the hills of South India. We blend, roast, and ship within 72 hours of order.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="label-mono mb-4">Explore</div>
          <ul className="space-y-2 text-[var(--text-secondary)]">
            <li><Link className="link-underline" to="/shop">Shop Blends</Link></li>
            <li><Link className="link-underline" to="/blend">Custom Blend</Link></li>
            <li><Link className="link-underline" to="/story">Our Story</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="label-mono mb-4">Contact</div>
          <p className="text-[var(--text-secondary)]">
            Rudra Roast Coffee <br />
            Shimoga, Karnataka <br />
            rudraroastsmg@gmail.com <br />
            +91 94810 91150
          </p>
        </div>
      </div>

      {/* Visitors counter */}
      <div className="border-t border-[var(--border)]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-center gap-4" data-testid="visitors-counter">
          <div
            className="flex items-center gap-4 px-6 py-3"
            style={{
              background: "linear-gradient(180deg, var(--surface) 0%, var(--surface-warm) 100%)",
              border: "1px solid var(--border-strong)",
              boxShadow: "var(--shadow-warm)",
            }}
          >
            <span
              className="inline-block w-2.5 h-2.5 rounded-full"
              style={{ background: "var(--primary)", boxShadow: "0 0 0 3px rgba(92,203,133,0.25)", animation: "badge-blink 1.6s ease-in-out infinite" }}
              aria-hidden
            />
            <span className="label-mono text-[var(--text-secondary)]">Total Visitors</span>
            <span
              className="font-mono text-xl md:text-2xl text-[var(--primary)] tabular-nums"
              data-testid="visitors-count"
            >
              {visitors === null ? "— — —" : visitors.toLocaleString("en-IN")}
            </span>
          </div>
          <span className="label-mono text-[10px] text-[var(--text-muted)] hidden md:inline">
            Thank you for brewing with us
          </span>
        </div>
      </div>

      <div className="border-t border-[var(--border)]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-5 flex flex-wrap gap-3 justify-between label-mono text-[10px]">
          <span>© 2026 Rudra Roast Coffee. All rights reserved.</span>
          <span>Hand-roasted · Batch tracked · Freshly ground</span>
        </div>
      </div>
    </footer>
  );
}
